import { generateClient } from "aws-amplify/api";
import { esQuery } from "src/graphql/queries";
import moment from "moment";

export async function downloadSMS(status, campaignId, tenantId, startDate, endDate) {
    const client = generateClient();

    let query = {
        "query": {
            "bool": {
                "must": [
                    {
                        "term": {
                            "tenant.keyword": tenantId
                        }
                    },
                    {
                        "match_phrase": {
                            "activityLogCampaignId": campaignId
                    }
                    },
                    {
                        "match_phrase": {
                            "type": "SMS"
                        }
                    },
                    {
                        "range": {
                            "createdAt": {
                                "gte": startDate ? startDate : moment().startOf('day').toISOString(),
                                "lte": endDate ? endDate : moment().toISOString()
                            }
                        }
                    }
                ]
            }
        },
        "_source": [
            "activityLogContactId",
            "pocActual",
            "timestamp",
            "title",
            "metaData.contactExternalId"
        ],
        "size": 10000
    };

    if (status) {
        query.query.bool.must.push({
            "match_phrase": {
                "title": status
            }
        });
    }

    const results = await client.graphql({
        query: esQuery,
        variables: {
            model: 'activitylog-*',
            action: '_search',
            query: JSON.stringify(query)
        }
    });

    const resulData = JSON.parse(results.data.esQuery).hits.hits;

    let csvData = "Velocity Id,External Id,Phone Number,Title,Timestamp\n";
    resulData.forEach(item => {
        const source = item._source;
        csvData += `${source.activityLogContactId || ''},${source.metaData?.contactExternalId || ''},${source.pocActual || ''},${source.title || ''},${source.timestamp || ''}\n`;
    });

    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `SMS_Campaign_${campaignId || 'All'}_${new Date().toISOString()}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

